import * as React from "react";
import { QueryRenderer, createFragmentContainer, ReadyState } from "react-relay";

// internal
import { TeamSearchInput } from "./TeamSearchInput";
import { IRendererProps, IRendererState } from "./TeamSearchInput.d";
import { fragments, query } from "./TeamSearchInputRenderer.gql";

// util
import { getCurrentOrg } from "@util/org.util";

class TeamSearchInputRendererComponent extends React.Component<IRendererProps, IRendererState> {
  constructor(props: IRendererProps) {
    super(props);

    this.state = {
      teamName: props.initialTeamName || "",
    };
  }

  public render() {
    const { onChange, org } = this.props;

    return (
      <QueryRenderer
        variables={{
          orgRelayId: org.id,
          query: this.state.teamName,
        }}
        query={query}
        environment={this.props.relay.environment}
        render={(readyState: ReadyState) => {
          const viewer = (readyState && readyState.props && readyState.props.viewer) || null;
          const org = getCurrentOrg(viewer);

          return (
            <TeamSearchInput
              onChange={onChange}
              org={org}
              viewer={viewer}
              initialTeamName={this.state.teamName}
            />
          );
        }}
      />
    );
  }
}

///////////
// Relay //
///////////

export const TeamSearchInputRenderer = createFragmentContainer(
  TeamSearchInputRendererComponent,
  fragments,
);
